// prop-types is a library for typechecking of props
import PropTypes from "prop-types";
import { useState } from "react";
import MDInput from "components/MDInput";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

import { countryCodesData } from "utilities/countryCodesData.js";

function Autocomplete({ onSelect, label, defaultValue }) {
  function getDefaultPrefixValue() {
    const indexOf = countryCodesData.findIndex((el) => el.dial_code === defaultValue);
    if (indexOf >= 0) {
      return countryCodesData[indexOf].dial_code + " " + countryCodesData[indexOf].flag;
    }
    return "";
  }
  const [inputValue, setInputValue] = useState(defaultValue ? getDefaultPrefixValue() : "");
  const [listToShow, setListToShow] = useState([]);
  const [indexSelected, setIndexSelected] = useState(0);
  return (
    <div className="autocomplete-container">
      <MDInput
        type="input"
        label={label}
        fullWidth
        value={inputValue}
        autoComplete={"off"}
        onChange={(e) => {
          setInputValue(e.target.value);
          if (e.target.value) {
            const newList = []
              .concat(countryCodesData)
              .filter((el) => !!el)
              .filter(
                (el) =>
                  el.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
                  el.dial_code.includes(e.target.value)
              );
            setListToShow(newList);
          } else {
            setListToShow([]);
            onSelect(null);
          }
        }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            if (indexSelected >= 0 && listToShow[indexSelected]) {
              onSelect(listToShow[indexSelected]);
              setInputValue(
                listToShow[indexSelected].dial_code + " " + listToShow[indexSelected].flag
              );
              setListToShow([]);
            }
          } else if (e.key === "ArrowDown") {
            if (indexSelected + 1 < listToShow.length) {
              setIndexSelected(indexSelected + 1);
            } else {
              setIndexSelected(0);
            }
          } else if (e.key === "ArrowUp") {
            if (indexSelected > 0) {
              setIndexSelected(indexSelected - 1);
            } else if (listToShow.length > 0) {
              setIndexSelected(listToShow.length - 1);
            } else {
              setIndexSelected(0);
            }
          } else if (e.key === "Escape") {
            setListToShow([]);
            onSelect(null);
            setInputValue("");
          }
        }}
      />
      {(listToShow && listToShow.length > 0) || inputValue ? (
        <IconButton
          onClick={() => {
            setListToShow([]);
            onSelect(null);
            setInputValue("");
          }}
          style={{ position: "absolute", right: "0", top: "5px" }}
          size="small"
          disableRipple
        >
          <Icon fontSize="medium">close</Icon>
        </IconButton>
      ) : null}
      {listToShow && listToShow.length > 0 ? (
        <div className="autocomplete-list-container" style={{ maxHeight: "130px" }}>
          {listToShow.map((option, index) => (
            <button
              className={`autocomplete-list-option ${
                indexSelected === index ? "option-selected" : ""
              }`}
              type="button"
              onClick={() => {
                onSelect(option);
                setInputValue(option.dial_code + " " + option.flag);
                setListToShow([]);
              }}
              key={`autocomplete-list-${label}-${index.toString()}`}
            >
              {option.flag} {option.dial_code} {option.name}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}

// Typechecking props for the Autocomplete
Autocomplete.propTypes = {
  onSelect: PropTypes.func.isRequired,
  label: PropTypes.string,
  defaultValue: PropTypes.string,
};

Autocomplete.defaultProps = {
  label: "",
  defaultValue: "",
};

export default Autocomplete;
